import { ESTADOS_UF, REGIOES, estadosDaRegiao } from "../../../utils/localidades";
import { Filtros } from "./painel";

const AGRUPAMENTOS = [
  { valor: "regiao", rotulo: "Região" },
  { valor: "estado", rotulo: "Estado" },
  { valor: "cidade", rotulo: "Cidade" },
];

// Região, estado e "agrupar por". Compartilhado entre "plantios" e "usuários".
//
// Cidade só faz sentido dentro de UM estado (há cidades homônimas em estados
// diferentes e a lista nacional seria enorme), então o botão fica desligado
// enquanto nenhum estado é escolhido, e limpar o estado volta o agrupamento
// para "estado".
export default function FiltrosLocalidade({ valores, onChange }) {
  const { regiao, estado, agrupar } = valores;

  function mudarRegiao(nova) {
    const aindaValido = !nova || !estado || estadosDaRegiao(nova).some((e) => e.uf === estado);
    onChange({
      regiao: nova,
      estado: aindaValido ? estado : "",
      agrupar: agrupar === "cidade" && !aindaValido ? "estado" : agrupar,
    });
  }

  function mudarEstado(novo) {
    const doEstado = ESTADOS_UF.find((e) => e.uf === novo);
    onChange({
      estado: novo,
      // Escolher o estado já posiciona a região dele.
      regiao: doEstado ? doEstado.regiao : regiao,
      agrupar: !novo && agrupar === "cidade" ? "estado" : agrupar,
    });
  }

  return (
    <>
      <div className="campo">
        <label htmlFor="agrupar-regiao">Agrupar por</label>
        <div className="segmentado" role="group" aria-label="Agrupar por">
          {AGRUPAMENTOS.map((item) => (
            <button key={item.valor} type="button" aria-pressed={agrupar === item.valor}
              disabled={item.valor === "cidade" && !estado}
              title={item.valor === "cidade" && !estado ? "Escolha um estado para ver por cidade" : undefined}
              onClick={() => onChange({ agrupar: item.valor })}>
              {item.rotulo}
            </button>
          ))}
        </div>
      </div>

      <div className="campo">
        <label htmlFor="filtro-regiao">Região</label>
        <select id="filtro-regiao" value={regiao} onChange={(e) => mudarRegiao(e.target.value)}>
          <option value="">Todas</option>
          {REGIOES.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>

      <div className="campo">
        <label htmlFor="filtro-estado">Estado</label>
        <select id="filtro-estado" value={estado} onChange={(e) => mudarEstado(e.target.value)}>
          <option value="">Todos</option>
          {estadosDaRegiao(regiao).map((e) => <option key={e.uf} value={e.uf}>{e.nome}</option>)}
        </select>
      </div>
    </>
  );
}

export { Filtros };
